import React, { useCallback, useEffect, useState } from 'react';

const Search = ({ onSearch, delay = 300, placeholder = 'Search' }) => {
  const [inputValue, setInputValue] = useState('');

  const debounce = (func, wait) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), wait);
    };
  };

  const debouncedSearch = useCallback(debounce(onSearch, delay), [
    onSearch,
    delay,
  ]);

  useEffect(() => {
    debouncedSearch(inputValue);
  }, [inputValue, debouncedSearch]);

  const handleChange = (e) => {
    setInputValue(e.target.value);
  };

  const withoutVerticalPadding = {
    paddingTop: 0,
    paddingBottom: 0,
    height: 36,
  };

  return (
    <div className='input-group'>
      <span className='input-group-addon' style={withoutVerticalPadding}>
        <i className='fas fa-search' />
      </span>
      <input
        type='search'
        value={inputValue}
        onChange={handleChange}
        placeholder={placeholder}
        className='form-control'
        style={{
          appearance: 'searchfield',
          borderTopRightRadius: 4,
          borderBottomRightRadius: 4,
          ...withoutVerticalPadding,
        }}
        aria-label='Search'
      />
    </div>
  );
};

export default Search;
